import { extend } from 'vee-validate'
import {
  image as rule_image,
  size as rule_size,
  required_if as rule_required_if,
} from 'vee-validate/dist/rules'
import { positiveValidator, passwordValidator } from './validators'
import maxDimensionsRule from './validatorRules'

export const image = extend('image', rule_image)
export const size = extend('size', rule_size)
export const requiredIf = extend('required_if', rule_required_if)
export const positive = extend('positive', {
  validate: positiveValidator,
  message: 'یک عدد مثبت وارد کنید!',
})
export const passwordLength = extend('passwordLength', {
  validate: passwordValidator,
  message: 'حداقل طول رمز عبور 8 حرف',
})

// export const maxDimensions = extend('maxdimensions', {
//   validate: maxDimensionsValidator,
//   // message: 'ابعاد {_field_} بیشتر از حد مجاز است',
//   // message: (field, args) => ` ${field} ابعاد بیشتر از حد مجاز ${args[0]} * ${args[1]}`,
// })

export const maxDimensions = extend('maxdimensions', maxDimensionsRule)
